import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = {
  key: 0,
  class: "campus-seccion"
}
const _hoisted_3 = { class: "campus-pills-preview" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "campus-caret" }
const _hoisted_6 = {
  key: 0,
  class: "campus-cuerpo"
}
const _hoisted_7 = { class: "campus-chips" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "campus-form"
}
const _hoisted_10 = { class: "campus-form-campos" }
const _hoisted_11 = { class: "campus-form-acciones" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "cargando-est"
}
const _hoisted_15 = {
  key: 2,
  class: "org-wrap"
}
const _hoisted_16 = {
  key: 0,
  class: "foco-bar"
}
const _hoisted_17 = { class: "foco-info" }
const _hoisted_18 = { class: "foco-nombre" }
const _hoisted_19 = {
  key: 0,
  class: "foco-dep"
}
const _hoisted_20 = {
  key: 1,
  class: "foco-dep"
}
const _hoisted_21 = { class: "foco-acciones" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  class: "matriz",
  ref: "matrizRef"
}
const _hoisted_25 = {
  key: 0,
  class: "separador-fila"
}
const _hoisted_26 = { class: "nivel-badge" }
const _hoisted_27 = {
  key: 0,
  class: "nivel-vacia-body"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "nivel-areas"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "panel-detalle"
}
const _hoisted_32 = {
  key: 1,
  class: "separador-fila"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 3,
  class: "reasignar-overlay"
}
const _hoisted_35 = { class: "reasignar-panel" }
const _hoisted_36 = { class: "reasignar-lista" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "reasignar-acciones" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]

import { ref, computed, onMounted, onUnmounted, provide, reactive } from 'vue'
import { useGestionProgramas } from '@/store/GestionPrograma'
import { useGestionCampus } from '@/store/GestionCampus'
import type { Programa } from '@/interfaces/Programa'
import type { Campus } from '@/interfaces/Campus'
import AreaModal from '@/components/AreaModal.vue'
import AreaCard from '@/components/AreaCard.vue'
import RegistrosSniesPanel from '@/components/RegistrosSniesPanel.vue'
import InstitucionPanel from '@/components/InstitucionPanel.vue'
import DirectivosPanel from '@/components/DirectivosPanel.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'

type FilaDisplay =
  | { tipo: 'real'; areas: Programa[] }
  | { tipo: 'vacia'; id: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'GestionAreasView',
  setup(__props) {

/**
 * Árbol organizacional de áreas: sedes, facultades y programas.
 *
 * Sin límite de profundidad, a diferencia del árbol de componentes. Es un bosque:
 * admite varias raíces, una por sede.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/gestion-areas` (GestionAreas) — permiso `campus.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const store       = useGestionProgramas()
const campusStore = useGestionCampus()

const cargando        = ref(false)
const procesando      = ref(false)
const mostrarGestionCampus  = ref(false)
const campusSeleccionado    = ref<Campus | null>(null)
const campusFiltro          = ref<number | null>(null)
const modoCampus            = ref<'crear' | 'editar' | null>(null)
const guardandoCampus       = ref(false)
const campusParaEliminar    = ref<Campus | null>(null)
const formCampus = reactive({ nombre: '', estado: 'activo' as 'activo' | 'inactivo' })
const modalVisible    = ref(false)
const areaSeleccionada  = ref<Programa | null>(null)
const areaParaEliminar  = ref<Programa | null>(null)
const modalRef          = ref<InstanceType<typeof AreaModal> | null>(null)
const filasManual       = ref<FilaDisplay[] | null>(null)
const cardSeleccionada      = ref<Programa | null>(null)
const cardSeleccionadaFilaIdx = ref(-1)
const filaDeCreacion        = ref(-1)
const modalReasignarVisible = ref(false)
const candidatasReasignar   = ref<Programa[]>([])
const seleccionadasArr      = ref<number[]>([])
const nuevaAreaReasignar    = ref<Programa | null>(null)
const mensajeVisible = ref(false)
const mensajeTexto   = ref('')
const mensajeTipo    = ref<'positivo' | 'error'>('positivo')

const contenedorRef = ref<HTMLElement | null>(null)
const panState = reactive({ active: false, startX: 0, startY: 0, scrollLeft: 0 })

function onPanStart(e: MouseEvent) {
  if ((e.target as HTMLElement).closest('button, input, select, label, a')) return
  panState.active     = true
  panState.startX     = e.clientX
  panState.scrollLeft = contenedorRef.value?.scrollLeft ?? 0
}

function onPanMove(e: MouseEvent) {
  if (!panState.active || !contenedorRef.value) return
  contenedorRef.value.scrollLeft = panState.scrollLeft - (e.clientX - panState.startX)
}

function onPanEnd() {
  panState.active = false
}

const arbol = computed(() => store.arbol)

const dragState = reactive<{
  dragging: Programa | null
  dropTargetId: number | null
  dropSide: 'before' | 'after'
}>({ dragging: null, dropTargetId: null, dropSide: 'after' })
provide('areaDragState', dragState)

// Filas display
function calcularNiveles(nodos: Programa[], prof = 0, acum: Programa[][] = []): Programa[][] {
  if (!nodos.length) return acum
  if (!acum[prof]) acum[prof] = []
  for (const n of nodos) {
    acum[prof].push(n)
    if (n.hijos_recursivos?.length) calcularNiveles(n.hijos_recursivos, prof + 1, acum)
  }
  return acum
}

const filasFromArbol = computed<FilaDisplay[]>(() =>
  calcularNiveles(arbol.value).map(areas => ({ tipo: 'real' as const, areas }))
)

const filasDisplay = computed<FilaDisplay[]>(() =>
  filasManual.value ?? filasFromArbol.value
)

// Opciones del modal
function aplanarExcluyendo(nodos: Programa[], excluirId: number | null, depth = 0): { id: number; label: string; nombre: string }[] {
  const result: { id: number; label: string; nombre: string }[] = []
  for (const n of nodos) {
    if (n.id_programa === excluirId) continue
    const indent = depth > 0 ? '  '.repeat(depth) + '– ' : ''
    result.push({ id: n.id_programa!, label: indent + n.nombre, nombre: n.nombre })
    if (n.hijos_recursivos?.length)
      result.push(...aplanarExcluyendo(n.hijos_recursivos, excluirId, depth + 1))
  }
  return result
}

const opcionesParaModal = computed(() =>
  aplanarExcluyendo(arbol.value, areaSeleccionada.value?.id_programa ?? null)
)

// Card seleccionada
function buscarEnArbol(nodos: Programa[], id: number): Programa | null {
  for (const n of nodos) {
    if (n.id_programa === id) return n
    const found = buscarEnArbol(n.hijos_recursivos ?? [], id)
    if (found) return found
  }
  return null
}

const padreDeSeleccionada = computed(() => {
  if (!cardSeleccionada.value?.padre_id) return null
  return buscarEnArbol(arbol.value, cardSeleccionada.value.padre_id)
})

function aplanarMapa(nodos: Programa[], acum: Map<number, Programa> = new Map()): Map<number, Programa> {
  for (const n of nodos) {
    if (n.id_programa) acum.set(n.id_programa, n)
    if (n.hijos_recursivos?.length) aplanarMapa(n.hijos_recursivos, acum)
  }
  return acum
}

const mapaAreas = computed(() => aplanarMapa(arbol.value))

const idsResaltados = computed<Set<number>>(() => {
  if (!cardSeleccionada.value?.id_programa) return new Set()
  const ids = new Set<number>()
  let actual: Programa | undefined = cardSeleccionada.value
  while (actual?.id_programa) {
    ids.add(actual.id_programa)
    actual = actual.padre_id ? mapaAreas.value.get(actual.padre_id) : undefined
  }
  return ids
})

function seleccionarCard(area: Programa, filaIdx: number) {
  if (cardSeleccionada.value?.id_programa === area.id_programa) {
    cardSeleccionada.value = null
    cardSeleccionadaFilaIdx.value = -1
  } else {
    cardSeleccionada.value = area
    cardSeleccionadaFilaIdx.value = filaIdx
  }
}

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value  = tipo
  mensajeVisible.value = true
}

// Carga
async function cargar(idCampus?: number | null) {
  cargando.value = true
  try {
    await store.cargarArbol(idCampus)
    filasManual.value = null
    cardSeleccionada.value = null
    cardSeleccionadaFilaIdx.value = -1
  } finally {
    cargando.value = false
  }
}

function toggleFiltroCampus(idCampus: number) {
  campusFiltro.value = campusFiltro.value === idCampus ? null : idCampus
  cargar(campusFiltro.value)
}

// Insertar / agregar filas
function insertarFilaEn(index: number) {
  const base = [...(filasManual.value ?? filasFromArbol.value)]
  base.splice(index, 0, { tipo: 'vacia', id: Math.random().toString(36).slice(2) })
  filasManual.value = base
}

function agregarFila() {
  const base = [...(filasManual.value ?? filasFromArbol.value)]
  filasManual.value = [...base, { tipo: 'vacia', id: Math.random().toString(36).slice(2) }]
}

// Abrir modal
function abrirCrearEnNivel(filaIndex: number) {
  filaDeCreacion.value = filaIndex
  areaSeleccionada.value = { nombre: '' }
  modalVisible.value = true
}

async function abrirEditar(area: Programa) {
  cardSeleccionada.value = null
  // Cargar área fresca por ID para obtener el campus array actualizado
  const fresca = area.id_programa ? await store.cargarPorId(area.id_programa) : null
  areaSeleccionada.value = fresca ? { ...fresca } : { ...area }
  modalVisible.value = true
}

function cerrarModal() {
  modalVisible.value = false
  areaSeleccionada.value = null
}

// Guardar
async function guardarArea(payload: {
  nombre: string
  tipo?: string
  nivel?: 'pregrado' | 'posgrado' | null
  padre_id: number | null
  facultad?: string | null
  campus_ids: number[]
}) {
  modalRef.value?.setGuardando(true)
  modalRef.value?.setError('')

  if (areaSeleccionada.value?.id_programa) {
    const idArea = areaSeleccionada.value.id_programa
    const result = await store.actualizar(idArea, {
      nombre:   payload.nombre,
      tipo:     payload.tipo,
      nivel:    payload.nivel    ?? undefined,
      padre_id: payload.padre_id ?? undefined,
      facultad: payload.facultad ?? undefined
    })
    if (!result.ok) {
      const msg = Object.values(result.errors ?? {}).flat().join(' ') || 'No se pudo actualizar.'
      modalRef.value?.setError(msg)
      modalRef.value?.setGuardando(false)
      return
    }

    // Sincronizar campus: añadir los nuevos, quitar los removidos
    const campusActuales = (areaSeleccionada.value.campus ?? []).map(c => c.id_campus)
    const agregar = payload.campus_ids.filter(id => !campusActuales.includes(id))
    const quitar  = campusActuales.filter(id => !payload.campus_ids.includes(id))
    await Promise.all([
      ...agregar.map(id => store.asignarCampus(idArea, id)),
      ...quitar.map(id  => store.desasignarCampus(idArea, id))
    ])

    cerrarModal()
    mostrarMensaje('Área actualizada correctamente.', 'positivo')
    await cargar()
  } else {
    const nombre  = payload.nombre
    const padreId = payload.padre_id
    const result  = await store.crear({
      nombre,
      tipo:     payload.tipo,
      nivel:    payload.nivel    ?? undefined,
      padre_id: padreId         ?? undefined,
      facultad: payload.facultad ?? undefined
    })
    if (!result.ok) {
      const msg = Object.values(result.errors ?? {}).flat().join(' ') || 'No se pudo crear.'
      modalRef.value?.setError(msg)
      modalRef.value?.setGuardando(false)
      return
    }

    // Asignar campus seleccionados al área recién creada
    const idNueva = result.data?.id_programa
    if (idNueva && payload.campus_ids.length) {
      await Promise.all(payload.campus_ids.map(id => store.asignarCampus(idNueva, id)))
    }

    // Detectar si fue creada en fila intermedia (vacia)
    const idx = filaDeCreacion.value
    const esIntermedia = idx >= 0 && filasDisplay.value[idx]?.tipo === 'vacia'
    filaDeCreacion.value = -1

    cerrarModal()
    mostrarMensaje('Área creada correctamente.', 'positivo')
    await cargar()

    // Seleccionar automáticamente el área recién creada
    for (let i = 0; i < filasDisplay.value.length; i++) {
      const fila = filasDisplay.value[i]
      if (fila.tipo !== 'real') continue
      const encontrada = fila.areas.find(
        a => a.nombre === nombre && (a.padre_id ?? null) === padreId
      )
      if (encontrada) {
        cardSeleccionada.value = encontrada
        cardSeleccionadaFilaIdx.value = i
        break
      }
    }

    // Si fue creada en fila intermedia y tiene padre, los demás hijos del padre son candidatos
    if (esIntermedia && idNueva && padreId !== null) {
      const padre = buscarEnArbol(arbol.value, padreId)
      const candidatas = (padre?.hijos_recursivos ?? []).filter(h => h.id_programa !== idNueva)
      if (candidatas.length > 0) {
        nuevaAreaReasignar.value = buscarEnArbol(arbol.value, idNueva)
        candidatasReasignar.value = candidatas
        seleccionadasArr.value = candidatas.map(a => a.id_programa!).filter(Boolean)
        modalReasignarVisible.value = true
      }
    }
  }
}

// Eliminar
function confirmarEliminar(area: Programa) {
  areaParaEliminar.value = area
}

async function ejecutarEliminar() {
  if (!areaParaEliminar.value?.id_programa || procesando.value) return
  procesando.value = true
  try {
    const result = await store.eliminar(areaParaEliminar.value.id_programa)
    areaParaEliminar.value = null
    if (result.ok) {
      mostrarMensaje('Área eliminada.', 'positivo')
      await cargar()
    } else {
      const msg = Object.values(result.errors ?? {}).flat().join(' ') || 'No se pudo eliminar.'
      mostrarMensaje(msg, 'error')
    }
  } finally {
    procesando.value = false
  }
}

// Reordenar
function encontrarHermanos(padreId: number | null | undefined, nodos: Programa[]): Programa[] {
  if (padreId == null) return nodos
  for (const n of nodos) {
    if (n.id_programa === padreId) return n.hijos_recursivos ?? []
    const found = encontrarHermanos(padreId, n.hijos_recursivos ?? [])
    if (found.length) return found
  }
  return []
}

// Campus CRUD
function abrirCrearCampus() {
  campusSeleccionado.value = null
  formCampus.nombre  = ''
  formCampus.estado  = 'activo'
  modoCampus.value   = 'crear'
}

function seleccionarCampus(campus: Campus) {
  if (campusSeleccionado.value?.id_campus === campus.id_campus) {
    campusSeleccionado.value = null
    modoCampus.value = null
    return
  }
  campusSeleccionado.value = campus
  formCampus.nombre  = campus.nombre
  formCampus.estado  = campus.estado ?? 'activo'
  modoCampus.value   = 'editar'
}

function cerrarFormCampus() {
  campusSeleccionado.value = null
  modoCampus.value  = null
  formCampus.nombre = ''
  formCampus.estado = 'activo'
}

async function guardarCampus() {
  if (!formCampus.nombre.trim()) return
  guardandoCampus.value = true
  try {
    if (modoCampus.value === 'editar' && campusSeleccionado.value) {
      const result = await campusStore.actualizar(campusSeleccionado.value.id_campus, {
        nombre: formCampus.nombre.trim(),
        estado: formCampus.estado
      })
      if (result.ok) {
        mostrarMensaje('Campus actualizado correctamente.', 'positivo')
        cerrarFormCampus()
      } else {
        const msg = Object.values(result.errors ?? {}).flat().join(' ') || 'No se pudo actualizar.'
        mostrarMensaje(msg, 'error')
      }
    } else {
      const result = await campusStore.crear({
        nombre: formCampus.nombre.trim(),
        estado: formCampus.estado
      })
      if (result.ok) {
        mostrarMensaje('Campus creado correctamente.', 'positivo')
        cerrarFormCampus()
      } else {
        const msg = Object.values(result.errors ?? {}).flat().join(' ') || 'No se pudo crear.'
        mostrarMensaje(msg, 'error')
      }
    }
  } finally {
    guardandoCampus.value = false
  }
}

function confirmarEliminarCampus(campus: Campus) {
  campusParaEliminar.value = campus
}

async function ejecutarEliminarCampus() {
  if (!campusParaEliminar.value) return
  procesando.value = true
  try {
    const result = await campusStore.eliminar(campusParaEliminar.value.id_campus)
    campusParaEliminar.value = null
    if (result.ok) {
      mostrarMensaje('Campus eliminado.', 'positivo')
      cerrarFormCampus()
    } else {
      const msg = Object.values(result.errors ?? {}).flat().join(' ') || 'No se pudo eliminar el campus.'
      mostrarMensaje(msg, 'error')
    }
  } finally {
    procesando.value = false
  }
}

async function onReordenar(payload: { dragged: Programa; target: Programa; side: 'before' | 'after' }) {
  const { dragged, target, side } = payload
  if (!dragged.id_programa || procesando.value) return
  procesando.value = true
  try {
    const hermanos   = encontrarHermanos(dragged.padre_id, arbol.value)
    const sinDragged = hermanos.filter(h => h.id_programa !== dragged.id_programa)
    const targetIdx  = sinDragged.findIndex(h => h.id_programa === target.id_programa)
    if (targetIdx === -1) return
    const nuevaPos = (side === 'before' ? targetIdx : targetIdx + 1) + 1
    const result = await store.reordenar(dragged.id_programa, nuevaPos)
    if (result.ok) await cargar()
    else mostrarMensaje(result.message ?? 'No se pudo reordenar.', 'error')
  } finally {
    procesando.value = false
  }
}

// Reasignación de padre
async function confirmarReasignar() {
  modalReasignarVisible.value = false
  const ids = [...seleccionadasArr.value]
  const nuevaId = nuevaAreaReasignar.value?.id_programa
  const snapshot = [...candidatasReasignar.value]
  nuevaAreaReasignar.value = null
  candidatasReasignar.value = []
  seleccionadasArr.value = []
  if (!ids.length || !nuevaId) return
  procesando.value = true
  try {
    await Promise.all(
      ids.map(id => {
        const area = snapshot.find(a => a.id_programa === id)
        if (!area) return Promise.resolve()
        return store.actualizar(id, {
          nombre:   area.nombre,
          tipo:     area.tipo,
          nivel:    area.nivel    ?? undefined,
          padre_id: nuevaId,
          facultad: (area as any).facultad ?? undefined
        })
      })
    )
    mostrarMensaje(`${ids.length} área(s) reasignadas correctamente.`, 'positivo')
    await cargar()
  } catch {
    mostrarMensaje('Error al reasignar áreas.', 'error')
  } finally {
    procesando.value = false
  }
}

function cancelarReasignar() {
  modalReasignarVisible.value = false
  nuevaAreaReasignar.value = null
  candidatasReasignar.value = []
  seleccionadasArr.value = []
}

onMounted(async () => {
  document.addEventListener('mousemove', onPanMove)
  document.addEventListener('mouseup', onPanEnd)
  await Promise.all([cargar(), campusStore.cargarTodos()])
})

onUnmounted(() => {
  document.removeEventListener('mousemove', onPanMove)
  document.removeEventListener('mouseup', onPanEnd)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "pg-header" }, [
      _createElementVNode("h1", null, "Estructura Organizacional"),
      _createElementVNode("p", { class: "pg-sub" }, "Cada fila representa un nivel organizacional. Haz clic en un área para ver su ruta y gestionarla.")
    ], -1)),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "pg-divider" }, null, -1)),
    (!cardSeleccionada.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "campus-cabecera",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (mostrarGestionCampus.value = !mostrarGestionCampus.value))
          }, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "campus-tit" }, "Campus", -1)),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campusStore).campus, (c) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: c.id_campus,
                  class: _normalizeClass(['c-pill-preview', { 'c-pill-activa': campusFiltro.value === c.id_campus }]),
                  onClick: _withModifiers(($event: any) => (toggleFiltroCampus(c.id_campus)), ["stop"])
                }, _toDisplayString(c.nombre), 11, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(mostrarGestionCampus.value ? '▴' : '▾'), 1)
          ]),
          (mostrarGestionCampus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campusStore).campus, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: c.id_campus,
                      class: _normalizeClass(['campus-chip', { 'campus-chip-activo': campusSeleccionado.value?.id_campus === c.id_campus }]),
                      onClick: ($event: any) => (seleccionarCampus(c))
                    }, _toDisplayString(c.nombre), 11, _hoisted_8))
                  }), 128)),
                  _createElementVNode("button", {
                    class: "campus-chip campus-chip-nuevo",
                    onClick: abrirCrearCampus
                  }, "+ Nuevo campus")
                ]),
                (modoCampus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formCampus.nombre) = $event)),
                          type: "text",
                          placeholder: "Nombre del campus",
                          class: "input-campus",
                          onKeyup: _withKeys(guardarCampus, ["enter"])
                        }, null, 544), [
                          [_vModelText, formCampus.nombre]
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formCampus.estado) = $event)),
                          class: "input-campus-select"
                        }, _cache[13] || (_cache[13] = [
                          _createElementVNode("option", { value: "activo" }, "Activo", -1),
                          _createElementVNode("option", { value: "inactivo" }, "Inactivo", -1)
                        ]), 512), [
                          [_vModelSelect, formCampus.estado]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        (modoCampus.value === 'editar')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn salir",
                              disabled: procesando.value,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmarEliminarCampus(campusSeleccionado.value!)))
                            }, "Eliminar", 8, _hoisted_12))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "btn salir",
                          onClick: cerrarFormCampus
                        }, "Cancelar"),
                        _createElementVNode("button", {
                          class: "btn guardar",
                          disabled: guardandoCampus.value,
                          onClick: guardarCampus
                        }, _toDisplayString(guardandoCampus.value ? 'Guardando...' : (modoCampus.value === 'editar' ? 'Guardar cambios' : 'Crear campus')), 9, _hoisted_13)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Cargando estructura... "))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (cardSeleccionada.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "btn-volver",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {cardSeleccionada.value = null; cardSeleccionadaFilaIdx.value = -1})
                }, "← Volver"),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(cardSeleccionada.value.nombre), 1),
                  (padreDeSeleccionada.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                        _cache[14] || (_cache[14] = _createTextVNode("depende de ")),
                        _createElementVNode("strong", null, _toDisplayString(padreDeSeleccionada.value.nombre), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_20, "Área raíz"))
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "btn guardar",
                    disabled: procesando.value,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (abrirEditar(cardSeleccionada.value!)))
                  }, "Modificar", 8, _hoisted_22),
                  _createElementVNode("button", {
                    class: "btn salir-foco",
                    disabled: procesando.value,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {confirmarEliminar(cardSeleccionada.value!); cardSeleccionada.value = null})
                  }, "Eliminar", 8, _hoisted_23)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["matriz-contenedor", { 'is-panning': panState.active }]),
            ref_key: "contenedorRef",
            ref: contenedorRef,
            onMousedown: onPanStart
          }, [
            _createElementVNode("div", _hoisted_24, [
              (!cardSeleccionada.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("button", {
                      class: "btn-insertar",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (insertarFilaEn(0)))
                    }, "+ Insertar fila")
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasDisplay.value, (fila, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: fila.tipo === 'vacia' ? fila.id : `real-${i}`
                }, [
                  (!cardSeleccionada.value || (
                fila.tipo === 'real' &&
                fila.areas.some(a => idsResaltados.value.has(a.id_programa!))
              ))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["nivel-fila", { 'nivel-vacia': fila.tipo === 'vacia' || !fila.areas.length }])
                        }, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(i + 1), 1),
                          (fila.tipo === 'vacia' || !fila.areas.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                (!cardSeleccionada.value)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn-agregar-vacio",
                                      onClick: ($event: any) => (abrirCrearEnNivel(i))
                                    }, " + Agregar área a esta fila ", 8, _hoisted_28))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((cardSeleccionada.value
                      ? fila.areas.filter(a => idsResaltados.value.has(a.id_programa!))
                      : fila.areas), (area) => {
                                  return (_openBlock(), _createBlock(AreaCard, {
                                    key: area.id_programa,
                                    area: area,
                                    nivel: i,
                                    seleccionada: cardSeleccionada.value?.id_programa === area.id_programa,
                                    "en-ruta": idsResaltados.value.size > 0 && idsResaltados.value.has(area.id_programa!) && cardSeleccionada.value?.id_programa !== area.id_programa,
                                    opaca: idsResaltados.value.size > 0 && !idsResaltados.value.has(area.id_programa!),
                                    onSeleccionar: ($event: any) => (seleccionarCard($event, i)),
                                    onReordenar: onReordenar
                                  }, null, 8, ["area", "nivel", "seleccionada", "en-ruta", "opaca", "onSeleccionar"]))
                                }), 128)),
                                (!cardSeleccionada.value)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn-nuevo-area",
                                      onClick: ($event: any) => (abrirCrearEnNivel(i)),
                                      title: "Agregar área en esta fila"
                                    }, "+", 8, _hoisted_30))
                                  : _createCommentVNode("", true)
                              ]))
                        ], 2),
                        (cardSeleccionada.value && cardSeleccionadaFilaIdx.value === i)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (cardSeleccionada.value.tipo === 'programa')
                                ? (_openBlock(), _createBlock(RegistrosSniesPanel, {
                                    key: 0,
                                    "id-programa": cardSeleccionada.value.id_programa!
                                  }, null, 8, ["id-programa"]))
                                : _createCommentVNode("", true),
                              (cardSeleccionada.value.tipo === 'institucion')
                                ? (_openBlock(), _createBlock(InstitucionPanel, { key: 1 }))
                                : _createCommentVNode("", true),
                              (cardSeleccionada.value.tipo !== 'programa')
                                ? (_openBlock(), _createBlock(DirectivosPanel, {
                                    key: 2,
                                    "id-area": cardSeleccionada.value.id_programa!
                                  }, null, 8, ["id-area"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (!cardSeleccionada.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("button", {
                                class: "btn-insertar",
                                onClick: ($event: any) => (insertarFilaEn(i + 1))
                              }, "+ Insertar fila", 8, _hoisted_33)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (!cardSeleccionada.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn-agregar-fila",
                    onClick: agregarFila
                  }, " + Agregar fila "))
                : _createCommentVNode("", true)
            ], 512)
          ], 34)
        ])),
    _createVNode(AreaModal, {
      ref_key: "modalRef",
      ref: modalRef,
      visible: modalVisible.value,
      area: areaSeleccionada.value,
      "opciones-planas": opcionesParaModal.value,
      "opciones-campus": _unref(campusStore).campus,
      onCancelar: cerrarModal,
      onGuardar: guardarArea
    }, null, 8, ["visible", "area", "opciones-planas", "opciones-campus"]),
    _createVNode(MensajeConfirmacion, {
      visible: !!campusParaEliminar.value,
      title: "Eliminar campus",
      message: `¿Desea eliminar el campus "${campusParaEliminar.value?.nombre ?? ''}"? Esta acción fallará si tiene áreas o procesos asociados.`,
      confirmText: "Eliminar",
      cancelText: "Cancelar",
      "confirm-loading": procesando.value,
      onConfirm: ejecutarEliminarCampus,
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (campusParaEliminar.value = null))
    }, null, 8, ["visible", "message", "confirm-loading"]),
    _createVNode(MensajeConfirmacion, {
      visible: !!areaParaEliminar.value,
      title: "Eliminar área",
      message: `¿Desea eliminar "${areaParaEliminar.value?.nombre ?? ''}"? Esta acción fallará si tiene sub-áreas o procesos asociados.`,
      confirmText: "Eliminar",
      cancelText: "Cancelar",
      "confirm-loading": procesando.value,
      onConfirm: ejecutarEliminar,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (areaParaEliminar.value = null))
    }, null, 8, ["visible", "message", "confirm-loading"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[10] || (_cache[10] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"]),
    (modalReasignarVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[16] || (_cache[16] = _createElementVNode("h3", null, "Reasignar dependencias", -1)),
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(nuevaAreaReasignar.value?.nombre), 1),
              _cache[15] || (_cache[15] = _createTextVNode(" fue insertada en una fila intermedia. Selecciona cuáles áreas de la fila de abajo deberían depender ahora de ella: "))
            ]),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidatasReasignar.value, (a) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: a.id_programa,
                  class: "reasignar-item"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: a.id_programa,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((seleccionadasArr).value = $event))
                  }, null, 8, _hoisted_37), [
                    [_vModelCheckbox, seleccionadasArr.value]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(a.nombre), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                class: "btn salir",
                disabled: procesando.value,
                onClick: cancelarReasignar
              }, "Omitir", 8, _hoisted_39),
              _createElementVNode("button", {
                class: "btn guardar",
                disabled: procesando.value || !seleccionadasArr.value.length,
                onClick: confirmarReasignar
              }, _toDisplayString(procesando.value ? 'Guardando...' : 'Confirmar'), 9, _hoisted_40)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})